class BlockVideo {
	constructor() {
		this.videos = document.querySelectorAll(".block-video");

		if (this.videos) {
			this.buildVideos();
		}
	}

	buildVideos() {
		this.videos.forEach(video => {
			const player = video.querySelector(".video-container");

			video.addEventListener("click", () => {
				video.classList.add("video-playing");
			});
		});
	}

}